import useApi from '../api';

export async function submitCreatePlayerSubscription(subscriptionCreationOptions: any) {
  const { post } = useApi();
  const subscriptionCreationOptionsPrepared = subscriptionCreationOptions;
  
  const { responseBody } = await post('api/playersubscriptions', subscriptionCreationOptionsPrepared, {isLogoutOnInvalidAuth: true});
  const responseData = responseBody;
  return responseData;
}